import { createContext, useContext } from 'react';
import { A4_LANDSCAPE } from '@/constants/pageFormat';
import PageHeader, { type PageHeaderBrand } from '@/components/blocks/PageHeader';
import type { SheetLayout } from './sheetPagination';

const SheetLayoutContext = createContext<SheetLayout | null>(null);

export const SheetLayoutProvider = SheetLayoutContext.Provider;

interface SheetContinuationHeadersProps {
  blockId: string;
  clientLogoUrl?: string;
  agencyLogoUrl?: string;
  brand: PageHeaderBrand;
  variant: 'light' | 'dark';
}

/**
 * Kop met klant- en UBO-logo bovenaan elk vervolgvel van een lang blok. De
 * paginering houdt daar ruimte voor vrij; de kop zelf staat los van de inhoud
 * (absoluut) en verandert de layout dus niet. Alleen in de klantweergave en PDF.
 */
export function SheetContinuationHeaders({ blockId, ...header }: SheetContinuationHeadersProps) {
  const layout = useContext(SheetLayoutContext);
  const sheetCount = layout?.blocks.find((block) => block.id === blockId)?.sheetCount ?? 1;
  if (!layout || sheetCount < 2) return null;

  return (
    <>
      {Array.from({ length: sheetCount - 1 }, (_, index) => (
        <div
          key={index}
          data-sheet-overlay
          contentEditable={false}
          aria-hidden
          style={{
            position: 'absolute',
            top: (index + 1) * layout.pitch + A4_LANDSCAPE.padding,
            left: A4_LANDSCAPE.padding,
            right: A4_LANDSCAPE.padding,
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        >
          <PageHeader {...header} />
        </div>
      ))}
    </>
  );
}
